import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 4,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (value: number) => value.toString().padStart(2, '0');
  return <div className="bg-holistic-wine text-white py-3 px-4 text-center text-sm md:text-base font-medium sticky top-0 z-50" data-id="element-186">
      <div className="flex flex-col md:flex-row items-center justify-center gap-2 md:gap-4" data-id="element-187">
        <span className="flex items-center gap-2" data-id="element-188">
          <span className="text-holistic-gold-light font-bold" data-id="element-189">
            ⚠️ OFERTA DE LANZAMIENTO:
          </span>
          <span data-id="element-190">
            Accede hoy con un 60% de descuento y llévate 4 Bonos de regalo.
          </span>
        </span>
        <div className="flex items-center gap-2 bg-white/20 px-3 py-1 rounded-full" data-id="element-191">
          <Clock size={16} className="text-holistic-gold-light" data-id="element-192" />
          <span className="font-mono tracking-wider" data-id="element-193">
            {formatTime(timeLeft.hours)}:{formatTime(timeLeft.minutes)}:
            {formatTime(timeLeft.seconds)}
          </span>
        </div>
      </div>
    </div>;
}